import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import customLocalStorage from "./customLocalStorage";
var EVENTS = {
  PAGE_VIEW: 'page_view',
  CLICK: 'click',
  TRAILER: 'trailer',
  RECOMMENDATION_POSITION_CHECKOUT: 'recommendation_position_checkout',
  RECOMMENDATION_POSITION_CLICK: 'recommendation_position_click',
  RECOMMENDATION_VIEW: 'recommendation_view',
  FIRST_PLAY: 'play'
};
var crehanaTrackUrl = process.env.NODE_ENV === 'production' ? '/api/v3/user-activity/' : 'https://qa.creha.co/api/v3/user-activity/';
var userActivity = {
  track: function track(eventType, customData, nextUrl) {
    var userData = customLocalStorage.getItem('creh-tracking-data');
    if (userData) {
      if (process.env.NODE_ENV !== 'production') {}
      var parsedUserData = JSON.parse(userData);
      var payload = [_objectSpread(_objectSpread(_objectSpread({}, customData), {}, {
        app_platform: 'web',
        event_type: eventType
      }, parsedUserData), {}, {
        identifier: "".concat(parsedUserData.username, "-").concat(parsedUserData.originalId),
        event_date: new Date().toISOString(),
        created_at: new Date().toISOString()
      })];
      return fetch(crehanaTrackUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json();
      }).then(function () {
        if (nextUrl) {
          window.location.href = nextUrl;
          return undefined;
        }
        return {
          name: 'userActivity',
          success: true
        };
      })["catch"](function () {
        if (nextUrl) {
          window.location.href = nextUrl;
          return undefined;
        }
        return {
          name: 'userActivity',
          success: false
        };
      });
    }
    if (nextUrl) {
      window.location.href = nextUrl;
    }
    return undefined;
  },
  EVENTS: EVENTS
};
export default userActivity;